import {
  CalendarPlus, CalendarCheck, SignIn, SignOut, XCircle, UserMinus, Ticket, Gift,
  ClockCounterClockwise, Star, Hourglass, GitFork, ChatCircle, Envelope, DeviceMobile, Bell,
  Tag, UserGear, ClipboardText, Megaphone, Lightning, Globe, Flag, Percent,
  Timer, Users, NotePencil,
} from "@phosphor-icons/react";

export const CATEGORIES = {
  trigger: { label: "Trigger", color: "#F59E0B", bg: "bg-amber-50", border: "border-amber-400" },
  wait: { label: "Attesa", color: "#71717A", bg: "bg-zinc-50", border: "border-zinc-400" },
  condition: { label: "Condizione", color: "#3B82F6", bg: "bg-blue-50", border: "border-blue-400" },
  action: { label: "Azione", color: "#10B981", bg: "bg-emerald-50", border: "border-emerald-400" },
};

export const TRIGGERS = [
  { kind: "prenotazione_creata", label: "Prenotazione creata", icon: CalendarPlus },
  { kind: "prenotazione_confermata", label: "Prenotazione confermata", icon: CalendarCheck },
  { kind: "cliente_arrivato", label: "Cliente IN (arrivato)", icon: SignIn },
  { kind: "cliente_out", label: "Cliente OUT", icon: SignOut },
  { kind: "prenotazione_cancellata", label: "Prenotazione cancellata", icon: XCircle },
  { kind: "no_show", label: "No-show", icon: UserMinus },
  { kind: "coupon_scaricato", label: "Coupon scaricato", icon: Ticket },
  { kind: "coupon_non_utilizzato", label: "Coupon non utilizzato", icon: Ticket },
  { kind: "coupon_utilizzato", label: "Coupon utilizzato", icon: Percent },
  { kind: "compleanno", label: "Compleanno cliente", icon: Gift },
  { kind: "cliente_inattivo", label: "Cliente inattivo da X giorni", icon: ClockCounterClockwise, defaults: { days: 30 } },
  { kind: "prima_visita", label: "Prima visita", icon: Star },
  { kind: "tempo_arrivo", label: "Tempo all'arrivo (X ore prima/dopo)", icon: Timer, defaults: { hours: 3, direction: "prima" } },
  { kind: "prenotazione_rifiutata", label: "Prenotazione rifiutata", icon: XCircle },
  { kind: "ingresso_lista_attesa", label: "Ingresso in lista d'attesa", icon: Hourglass },
  { kind: "prenotazione_annullata_cliente", label: "Prenotazione annullata dal cliente", icon: XCircle },
  { kind: "prenotazione_modificata_cliente", label: "Prenotazione modificata dal cliente", icon: NotePencil },
  { kind: "coda_nuovo_ingresso", label: "Cliente entrato in coda", icon: Users },
  { kind: "cliente_uscito_dalla_coda", label: "Cliente uscito dalla coda", icon: SignOut },
  { kind: "nuovo_cliente", label: "Nuovo cliente registrato", icon: UserGear },
  { kind: "sondaggio_compilato", label: "Sondaggio compilato", icon: ClipboardText },
  { kind: "gift_card_assegnata", label: "Gift card assegnata", icon: Gift },
  { kind: "gift_card_utilizzata", label: "Gift card utilizzata", icon: Gift },
  { kind: "tag_aggiunto", label: "Tag aggiunto al contatto", icon: Tag, defaults: { tag: "" } },
];

export const WAITS = [
  { kind: "attesa", label: "Attesa", icon: Hourglass, defaults: { unit: "giorni", value: 1 } },
];

export const CONDITIONS = [
  { kind: "ha_confermato", label: "Ha confermato?", icon: CalendarCheck },
  { kind: "ha_aperto", label: "Ha aperto il messaggio?", icon: Envelope },
  { kind: "ha_cliccato", label: "Ha cliccato?", icon: Lightning },
  { kind: "ha_usato_coupon", label: "Ha utilizzato il coupon?", icon: Ticket },
  { kind: "coupon_prenotato", label: "Ha prenotato con il coupon?", icon: Ticket, coupon_select: true },
  { kind: "numero_visite", label: "Numero visite", icon: UserGear, defaults: { operator: ">=", value: 3 } },
  { kind: "spesa_totale", label: "Spesa totale", icon: GitFork, defaults: { operator: ">=", value: 100 } },
  { kind: "voto_sondaggio", label: "Voto sondaggio (0-10)", icon: Star, defaults: { operator: ">=", value: 8 } },
  { kind: "consenso_marketing", label: "Consenso marketing", icon: Megaphone, defaults: { value: "si" } },
  { kind: "lingua", label: "Lingua cliente", icon: Globe, defaults: { value: "it" } },
  { kind: "tag", label: "Ha tag", icon: Tag, defaults: { value: "" } },
  { kind: "provenienza", label: "Provenienza (canale)", icon: GitFork, defaults: { value: "telefono" } },
  { kind: "giorno", label: "Giorno della settimana", icon: CalendarCheck, defaults: { days: [] } },
  { kind: "fascia_oraria", label: "Fascia oraria", icon: Hourglass, defaults: { from: "18:00", to: "23:00" } },
];

export const ACTIONS = [
  { kind: "invia_whatsapp", label: "Invia WhatsApp", icon: ChatCircle, message: true },
  { kind: "invia_email", label: "Invia Email", icon: Envelope, message: true },
  { kind: "invia_sms", label: "Invia SMS", icon: DeviceMobile, message: true },
  { kind: "invia_push", label: "Invia Push", icon: Bell, message: true },
  { kind: "invia_sondaggio", label: "Invia sondaggio", icon: ClipboardText, defaults: { survey_id: "", body: "", channel: "whatsapp" } },
  { kind: "crea_coupon", label: "Crea coupon", icon: Ticket, defaults: { name: "", description: "", valid_days: 30, conditions: "" } },
  { kind: "assegna_coupon", label: "Assegna coupon", icon: Ticket, defaults: { coupon_id: "" } },
  { kind: "aggiorna_stato_prenotazione", label: "Aggiorna stato prenotazione", icon: CalendarCheck, defaults: { status: "confermata" } },
  { kind: "aggiorna_cliente", label: "Aggiorna cliente", icon: UserGear, defaults: { field: "notes", value: "" } },
  { kind: "assegna_tag", label: "Assegna tag", icon: Tag, defaults: { tag: "" } },
  { kind: "rimuovi_tag", label: "Rimuovi tag", icon: Tag, defaults: { tag: "" } },
  { kind: "crea_attivita", label: "Crea attività", icon: ClipboardText, defaults: { text: "" } },
  { kind: "notifica_staff", label: "Notifica staff", icon: Megaphone, defaults: { message: "" } },
  { kind: "avvia_automazione", label: "Avvia altra automazione", icon: Lightning, defaults: { automation_id: "" } },
  { kind: "webhook", label: "Webhook", icon: Globe, defaults: { url: "" } },
  { kind: "fine", label: "Fine", icon: Flag, terminal: true },
];

export const EMAIL_TEMPLATES = [
  { k: "standard", label: "Email standard", defaults: {} },
  { k: "coupon_pdf", label: "Invia Coupon Generato (PDF con QR)", defaults: {
      subject: "Il tuo coupon {coupon_name} è pronto!",
      body: "Ciao {nome}, ecco il tuo coupon {coupon_name}.\nCodice: {codice}\nScarica il PDF con il QR code e mostralo in cassa.",
      cta_text: "Scarica il tuo coupon (PDF con QR)", cta_url: "{coupon_pdf_url}",
      cta2_text: "Prenota ora il tuo tavolo", cta2_url: "{web_form_url}" } },
  { k: "landing_coupon", label: "Invia Landing Coupon", defaults: {
      subject: "Per te: {coupon_name}",
      body: "Ciao {nome}, abbiamo pensato a un'offerta per te: {coupon_name}.\nClicca qui sotto per scaricare il tuo coupon.",
      cta_text: "Scarica il coupon", cta_url: "{coupon_url}" } },
  { k: "modulo_prenotazione", label: "Invia Modulo Prenotazione", defaults: {
      subject: "Prenota il tuo tavolo da {ristorante}",
      body: "Ciao {nome}, riserva il tuo tavolo in pochi secondi dal nostro modulo online.",
      cta_text: "Prenota ora", cta_url: "{web_form_url}" } },
  { k: "menu", label: "Invia Menu", defaults: {
      subject: "Il menu di {ristorante}",
      body: "Ciao {nome}, scopri i nostri piatti e le proposte del momento.",
      cta_text: "Sfoglia il menu", cta_url: "{menu_url}" } },
  { k: "sondaggio", label: "Invia Sondaggio", defaults: {
      subject: "Come è andata? La tua opinione conta",
      body: "Ciao {nome}, raccontaci la tua esperienza: ci aiuti a migliorare.",
      cta_text: "", cta_url: "" } },
  { k: "fidelity_card", label: "Invia Fidelity Card", defaults: {
      subject: "I tuoi punti fidelity da {ristorante}",
      body: "Ciao {nome}, vieni a scoprire i premi che puoi ottenere con le tue visite.",
      cta_text: "Prenota la tua prossima visita", cta_url: "{web_form_url}" } },
];

export const WA_TEMPLATES = [
  { k: "standard", label: "Messaggio libero", defaults: {} },
  { k: "modulo_prenotazione", label: "Invia Modulo Prenotazione", defaults: {
      body: "Ciao {nome}, riserva il tuo tavolo da {ristorante} in pochi secondi dal nostro modulo online:\n{web_form_url}" } },
  { k: "landing_coupon", label: "Invia Landing Coupon", defaults: {
      body: "Ciao {nome}, abbiamo pensato a un'offerta per te: {coupon_name}.\nScaricala qui: {coupon_url}" } },
  { k: "coupon_pdf", label: "Invia Coupon (PDF con QR)", defaults: {
      body: "Ciao {nome}, il tuo coupon {coupon_name} è pronto!\nCodice: {codice}\nScarica il PDF con il QR code: {coupon_pdf_url}" } },
  { k: "menu", label: "Invia Menu", defaults: {
      body: "Ciao {nome}, scopri i piatti e le proposte di {ristorante}:\n{menu_url}" } },
  { k: "sondaggio", label: "Invia Sondaggio", defaults: {
      body: "Ciao {nome}, come è andata la tua esperienza da {ristorante}? La tua opinione ci aiuta a migliorare." } },
  { k: "fidelity_card", label: "Invia Fidelity Card", defaults: {
      body: "Ciao {nome}, vieni a scoprire i premi fidelity che ti aspettano da {ristorante}.\nPrenota la tua prossima visita: {web_form_url}" } },
];

export const BLOCKS = [
  ...TRIGGERS.map((b) => ({ ...b, category: "trigger" })),
  ...WAITS.map((b) => ({ ...b, category: "wait" })),
  ...CONDITIONS.map((b) => ({ ...b, category: "condition" })),
  ...ACTIONS.map((b) => ({ ...b, category: "action" })),
];

export const VARIABLES = [
  { v: "{nome}", label: "Nome cliente" },
  { v: "{customer_name}", label: "Nome completo" },
  { v: "{data}", label: "Data prenotazione" },
  { v: "{ora}", label: "Ora" },
  { v: "{ristorante}", label: "Ristorante" },
  { v: "{coupon_name}", label: "Nome coupon" },
  { v: "{codice}", label: "Codice coupon" },
  { v: "{data_fine}", label: "Scadenza coupon" },
  { v: "{web_form_url}", label: "Link prenotazione (modulo web)" },
  { v: "{coupon_pdf_url}", label: "Link PDF coupon" },
  { v: "{coupon_url}", label: "Link landing coupon" },
  { v: "{menu_url}", label: "Link menu pubblico" },
];

export const WAIT_UNITS = [
  { value: "minuti", label: "Minuti" },
  { value: "ore", label: "Ore" },
  { value: "giorni", label: "Giorni" },
  { value: "settimane", label: "Settimane" },
  { value: "data", label: "Fino a una data" },
  { value: "evento", label: "Fino a un evento" },
];

export function blockDef(category, kind) {
  return BLOCKS.find((b) => b.category === category && b.kind === kind);
}

export function summarize(data) {
  const c = data.config || {};
  switch (data.kind) {
    case "attesa":
      if (c.unit === "data") return `fino al ${c.date || "—"} ${c.time || ""}`;
      if (c.unit === "evento") return `fino a: ${triggerLabel(c.event)}`;
      return `${c.value ?? 1} ${c.unit || "giorni"}`;
    case "cliente_inattivo": return `dopo ${c.days ?? 30} giorni`;
    case "tempo_arrivo": return `${c.hours ?? 3} ore ${c.direction === "dopo" ? "dopo" : "prima"} dell'arrivo`;
    case "tag_aggiunto": return c.tag ? `tag: ${c.tag}` : "qualsiasi tag";
    case "voto_sondaggio": return `voto ${c.operator || ">="} ${c.value ?? 8}`;
    case "numero_visite": return `${c.operator || ">="} ${c.value ?? 0} visite`;
    case "spesa_totale": return `${c.operator || ">="} €${c.value ?? 0}`;
    case "consenso_marketing": return c.value === "si" ? "ha dato consenso" : "senza consenso";
    case "lingua": return `lingua = ${c.value || "it"}`;
    case "tag": return c.value ? `tag: ${c.value}` : "";
    case "provenienza": return c.value ? `canale: ${c.value}` : "";
    case "giorno": return (c.days || []).length ? `${c.days.length} giorni selezionati` : "nessun giorno";
    case "fascia_oraria": return `${c.from || "—"} – ${c.to || "—"}`;
    case "invia_email": {
      const t = EMAIL_TEMPLATES.find((x) => x.k === c.email_template);
      const lbl = t && t.k !== "standard" ? t.label : "";
      const body = c.body ? c.body.slice(0, 40) + (c.body.length > 40 ? "…" : "") : "";
      return [lbl, body].filter(Boolean).join(" — ") || "messaggio vuoto";
    }
    case "invia_whatsapp": case "invia_sms": case "invia_push":
      return c.body ? c.body.slice(0, 60) + (c.body.length > 60 ? "…" : "") : "messaggio vuoto";
    case "crea_coupon": return c.name || "";
    case "aggiorna_stato_prenotazione": return `→ ${c.status || ""}`;
    case "aggiorna_cliente": return c.field ? `${c.field} = ${c.value}` : "";
    case "assegna_tag": case "rimuovi_tag": return c.tag || "";
    case "crea_attivita": return c.text || "";
    case "notifica_staff": return c.message || "";
    case "webhook": return c.url || "";
    default: return "";
  }
}

export function triggerLabel(kind) {
  return TRIGGERS.find((t) => t.kind === kind)?.label || kind || "—";
}
